<template>
  <v-container fluid dark class="mt-10 mb-12" :style="'overflow-y: scroll; max-height: 100%;'">
    <v-card dark>
      <v-container fluid>
        <v-row class="mt-4" v-if="method == ''">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h5 text-center">Wybierz metodę wysyłki &nbsp;<v-icon
                :style="'transform: translateY(-3px)'">fas fa-shipping-fast</v-icon></span>
          </v-col>
          <v-col cols="12">
            <v-divider class="mt-4 mb-4"></v-divider>

            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setShippingMethod('ip')"
              v-if="$store.state.shippingMethods.includes('ip')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/inpost.png"> </v-img>
                </v-card>
              </v-col>
              <v-col class="
                  d-flex
                  justify-lg-start justify-md-start
                  align-center
                  justify-center
                  text-center
                ">
                <span class="text-h6 text-center">Paczkomat InPost</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
          </v-col>

          <v-col cols="12">
            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setShippingMethod('pp')"
              v-if="$store.state.shippingMethods.includes('pp')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/poczta_polska.png" :style="'max-width: 200px; height: auto;'">
                  </v-img>
                </v-card>
              </v-col>
              <v-col class="
                  d-flex
                  justify-lg-start justify-md-start
                  align-center
                  justify-center
                  text-center
                ">
                <span class="text-h6 text-center">Przesyłka nierejestrowana Poczta Polska</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-4"></v-divider>
          </v-col>
          <v-col cols="12">
            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setShippingMethod('courier')"
              v-if="$store.state.shippingMethods.includes('courier')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/courier.png" :style="'max-width: 200px; height: auto;'">
                  </v-img>
                </v-card>
              </v-col>
              <v-col class="
                  d-flex
                  justify-lg-start justify-md-start
                  align-center
                  justify-center
                  text-center
                ">
                <span class="text-h6 text-center">Kurier</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-4"></v-divider>
          </v-col>
        </v-row>
        <v-row v-if="method == 'pp' || method == 'courier'">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h5 text-center">Dane do wysyłki &nbsp;<v-icon :style="'transform: translateY(-3px)'">fas
                fa-shipping-fast</v-icon></span>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <span :style="'color: #65ff6f;'">Twoje dane są szyfrowane &nbsp;<v-icon
                :style="'transform: translateY(-3px)'">fas fa-shield</v-icon></span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn @click="setShippingMethod('')">
              <v-icon>fas fa-chevron-left</v-icon> Wstecz
            </v-btn>
          </v-col>
          <v-divider></v-divider>
          <v-col cols="12" lg="6">
            <v-text-field v-model="email" label="E-mail" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field counter="20" v-model="firstName" label="Imię" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field counter="20" v-model="lastName" label="Nazwisko" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="8">
            <v-text-field counter="50" v-model="street" label="Ulica i numer" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="4">
            <v-text-field counter="10" v-model="aptNumber" label="Numer mieszkania" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field counter="6" v-model="zip" label="Kod pocztowy" required></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field counter="20" v-model="city" label="Miasto" required></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select :items="countries" label="Kraj" v-model="country" :disabled="method == 'pp'">
            </v-select>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <span :style="'color: #ff3636;'" class="text-h6" v-if="errorText.length > 0">{{ errorText }}</span>
          </v-col>
          <v-col cols="12">
            <v-btn class="mt-2" dark block @click="goToPaymentOptions()" v-if="$store.state.PSC"><v-icon
                :style="'color: green;'">fas fa-money-check-alt</v-icon>&nbsp;Opcje płatności</v-btn>
            <v-btn class="mt-2" dark block @click="goToPaymentOptions()" v-else><v-icon :style="'color: green;'">fas
                fa-clipboard-list</v-icon>&nbsp;Do podsumowania</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="method == 'ip'">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h5 text-center">Dane do wysyłki InPost &nbsp;<v-icon
                :style="'transform: translateY(-3px)'">fas fa-shipping-fast</v-icon></span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <span :style="'color: #65ff6f;'">Twoje dane są szyfrowane &nbsp;<v-icon
                :style="'transform: translateY(-3px)'">fas fa-shield</v-icon></span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn @click="setShippingMethod('')">
              <v-icon>fas fa-chevron-left</v-icon> Wstecz
            </v-btn>
          </v-col>
          <v-divider></v-divider>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn>
              <a href="https://inpost.pl/znajdz-paczkomat" target="_blank"><v-icon>fas
                  fa-map-marked</v-icon>&nbsp;Znajdź paczkomat</a>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field counter="11" v-model="boxId" label="Numer paczkomatu" hint="np. PND01B lub POP-ADM1" required
              @input="loadBoxText()"></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field v-model="email" label="E-mail" required></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6" :style="`color: ${boxText.includes('znaleziono') ? '#fb5757' : 'cyan'
              };`" v-if="boxText.length > 0"><v-icon>fas fa-map-marked</v-icon>&nbsp; {{ boxText }}</span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-alert border="top" colored-border type="info" elevation="2">
              <span>Paczka zostanie wysłana z losowym numerem telefonu oraz losowym
                imieniem i nazwiskiem odbiorcy. Powiadomienie z <span :style="'color: #536eff;'">kodem odbioru</span>
                dotrze na podanego maila.</span>
            </v-alert>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <span :style="'color: #ff3636;'" class="text-h6" v-if="errorText.length > 0">{{ errorText }}</span>
          </v-col>
          <v-col cols="12">
            <v-btn class="mt-2" dark block @click="goToPaymentOptions()" v-if="$store.state.PSC"><v-icon
                :style="'color: green;'">fas fa-money-check-alt</v-icon>&nbsp;Opcje płatności</v-btn>
            <v-btn class="mt-2" dark block @click="goToPaymentOptions()" v-else><v-icon :style="'color: green;'">fas
                fa-clipboard-list</v-icon>&nbsp;Do podsumowania</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

  </v-container>
</template>

<script>
export default {
  name: "OrderDetailsView",
  data: () => ({
    method: "",
    phoneNumber: "",
    email: "",
    boxId: "",
    boxText: "",
    boxTimeout: false,
    boxLoading: false,
    firstName: "",
    lastName: "",
    street: "",
    aptNumber: "",
    zip: "",
    city: "",
    countries: [
      {
        "text": "Poland",
        "value": "Poland"
      },
      {
        "text": "United States",
        "value": "United States"
      },
      {
        "text": "Canada",
        "value": "Canada"
      },
      {
        "text": "Afghanistan",
        "value": "Afghanistan"
      },
      {
        "text": "Albania",
        "value": "Albania"
      },
      {
        "text": "Algeria",
        "value": "Algeria"
      },
      {
        "text": "American Samoa",
        "value": "American Samoa"
      },
      {
        "text": "Andorra",
        "value": "Andorra"
      },
      {
        "text": "Angola",
        "value": "Angola"
      },
      {
        "text": "Anguilla",
        "value": "Anguilla"
      },
      {
        "text": "Antarctica",
        "value": "Antarctica"
      },
      {
        "text": "Antigua and/or Barbuda",
        "value": "Antigua and/or Barbuda"
      },
      {
        "text": "Argentina",
        "value": "Argentina"
      },
      {
        "text": "Armenia",
        "value": "Armenia"
      },
      {
        "text": "Aruba",
        "value": "Aruba"
      },
      {
        "text": "Australia",
        "value": "Australia"
      },
      {
        "text": "Austria",
        "value": "Austria"
      },
      {
        "text": "Azerbaijan",
        "value": "Azerbaijan"
      },
      {
        "text": "Bahamas",
        "value": "Bahamas"
      },
      {
        "text": "Bahrain",
        "value": "Bahrain"
      },
      {
        "text": "Bangladesh",
        "value": "Bangladesh"
      },
      {
        "text": "Barbados",
        "value": "Barbados"
      },
      {
        "text": "Belarus",
        "value": "Belarus"
      },
      {
        "text": "Belgium",
        "value": "Belgium"
      },
      {
        "text": "Belize",
        "value": "Belize"
      },
      {
        "text": "Benin",
        "value": "Benin"
      },
      {
        "text": "Bermuda",
        "value": "Bermuda"
      },
      {
        "text": "Bhutan",
        "value": "Bhutan"
      },
      {
        "text": "Bolivia",
        "value": "Bolivia"
      },
      {
        "text": "Bosnia and Herzegovina",
        "value": "Bosnia and Herzegovina"
      },
      {
        "text": "Botswana",
        "value": "Botswana"
      },
      {
        "text": "Bouvet Island",
        "value": "Bouvet Island"
      },
      {
        "text": "Brazil",
        "value": "Brazil"
      },
      {
        "text": "British Indian Ocean Territory",
        "value": "British Indian Ocean Territory"
      },
      {
        "text": "Brunei Darussalam",
        "value": "Brunei Darussalam"
      },
      {
        "text": "Bulgaria",
        "value": "Bulgaria"
      },
      {
        "text": "Burkina Faso",
        "value": "Burkina Faso"
      },
      {
        "text": "Burundi",
        "value": "Burundi"
      },
      {
        "text": "Cambodia",
        "value": "Cambodia"
      },
      {
        "text": "Cameroon",
        "value": "Cameroon"
      },
      {
        "text": "Cape Verde",
        "value": "Cape Verde"
      },
      {
        "text": "Cayman Islands",
        "value": "Cayman Islands"
      },
      {
        "text": "Central African Republic",
        "value": "Central African Republic"
      },
      {
        "text": "Chad",
        "value": "Chad"
      },
      {
        "text": "Chile",
        "value": "Chile"
      },
      {
        "text": "China",
        "value": "China"
      },
      {
        "text": "Christmas Island",
        "value": "Christmas Island"
      },
      {
        "text": "Cocos (Keeling) Islands",
        "value": "Cocos (Keeling) Islands"
      },
      {
        "text": "Colombia",
        "value": "Colombia"
      },
      {
        "text": "Comoros",
        "value": "Comoros"
      },
      {
        "text": "Congo",
        "value": "Congo"
      },
      {
        "text": "Cook Islands",
        "value": "Cook Islands"
      },
      {
        "text": "Costa Rica",
        "value": "Costa Rica"
      },
      {
        "text": "Croatia (Hrvatska)",
        "value": "Croatia (Hrvatska)"
      },
      {
        "text": "Cuba",
        "value": "Cuba"
      },
      {
        "text": "Cyprus",
        "value": "Cyprus"
      },
      {
        "text": "Czech Republic",
        "value": "Czech Republic"
      },
      {
        "text": "Denmark",
        "value": "Denmark"
      },
      {
        "text": "Djibouti",
        "value": "Djibouti"
      },
      {
        "text": "Dominica",
        "value": "Dominica"
      },
      {
        "text": "Dominican Republic",
        "value": "Dominican Republic"
      },
      {
        "text": "East Timor",
        "value": "East Timor"
      },
      {
        "text": "Ecudaor",
        "value": "Ecudaor"
      },
      {
        "text": "Egypt",
        "value": "Egypt"
      },
      {
        "text": "El Salvador",
        "value": "El Salvador"
      },
      {
        "text": "Equatorial Guinea",
        "value": "Equatorial Guinea"
      },
      {
        "text": "Eritrea",
        "value": "Eritrea"
      },
      {
        "text": "Estonia",
        "value": "Estonia"
      },
      {
        "text": "Ethiopia",
        "value": "Ethiopia"
      },
      {
        "text": "Falkland Islands (Malvinas)",
        "value": "Falkland Islands (Malvinas)"
      },
      {
        "text": "Faroe Islands",
        "value": "Faroe Islands"
      },
      {
        "text": "Fiji",
        "value": "Fiji"
      },
      {
        "text": "Finland",
        "value": "Finland"
      },
      {
        "text": "France",
        "value": "France"
      },
      {
        "text": "France, Metropolitan",
        "value": "France, Metropolitan"
      },
      {
        "text": "French Guiana",
        "value": "French Guiana"
      },
      {
        "text": "French Polynesia",
        "value": "French Polynesia"
      },
      {
        "text": "French Southern Territories",
        "value": "French Southern Territories"
      },
      {
        "text": "Gabon",
        "value": "Gabon"
      },
      {
        "text": "Gambia",
        "value": "Gambia"
      },
      {
        "text": "Georgia",
        "value": "Georgia"
      },
      {
        "text": "Germany",
        "value": "Germany"
      },
      {
        "text": "Ghana",
        "value": "Ghana"
      },
      {
        "text": "Gibraltar",
        "value": "Gibraltar"
      },
      {
        "text": "Greece",
        "value": "Greece"
      },
      {
        "text": "Greenland",
        "value": "Greenland"
      },
      {
        "text": "Grenada",
        "value": "Grenada"
      },
      {
        "text": "Guadeloupe",
        "value": "Guadeloupe"
      },
      {
        "text": "Guam",
        "value": "Guam"
      },
      {
        "text": "Guatemala",
        "value": "Guatemala"
      },
      {
        "text": "Guinea",
        "value": "Guinea"
      },
      {
        "text": "Guinea-Bissau",
        "value": "Guinea-Bissau"
      },
      {
        "text": "Guyana",
        "value": "Guyana"
      },
      {
        "text": "Haiti",
        "value": "Haiti"
      },
      {
        "text": "Heard and Mc Donald Islands",
        "value": "Heard and Mc Donald Islands"
      },
      {
        "text": "Honduras",
        "value": "Honduras"
      },
      {
        "text": "Hong Kong",
        "value": "Hong Kong"
      },
      {
        "text": "Hungary",
        "value": "Hungary"
      },
      {
        "text": "Iceland",
        "value": "Iceland"
      },
      {
        "text": "India",
        "value": "India"
      },
      {
        "text": "Indonesia",
        "value": "Indonesia"
      },
      {
        "text": "Iran (Islamic Republic of)",
        "value": "Iran (Islamic Republic of)"
      },
      {
        "text": "Iraq",
        "value": "Iraq"
      },
      {
        "text": "Ireland",
        "value": "Ireland"
      },
      {
        "text": "Israel",
        "value": "Israel"
      },
      {
        "text": "Italy",
        "value": "Italy"
      },
      {
        "text": "Ivory Coast",
        "value": "Ivory Coast"
      },
      {
        "text": "Jamaica",
        "value": "Jamaica"
      },
      {
        "text": "Japan",
        "value": "Japan"
      },
      {
        "text": "Jordan",
        "value": "Jordan"
      },
      {
        "text": "Kazakhstan",
        "value": "Kazakhstan"
      },
      {
        "text": "Kenya",
        "value": "Kenya"
      },
      {
        "text": "Kiribati",
        "value": "Kiribati"
      },
      {
        "text": "Korea, Democratic People's Republic of",
        "value": "Korea, Democratic People's Republic of"
      },
      {
        "text": "Korea, Republic of",
        "value": "Korea, Republic of"
      },
      {
        "text": "Kosovo",
        "value": "Kosovo"
      },
      {
        "text": "Kuwait",
        "value": "Kuwait"
      },
      {
        "text": "Kyrgyzstan",
        "value": "Kyrgyzstan"
      },
      {
        "text": "Lao People's Democratic Republic",
        "value": "Lao People's Democratic Republic"
      },
      {
        "text": "Latvia",
        "value": "Latvia"
      },
      {
        "text": "Lebanon",
        "value": "Lebanon"
      },
      {
        "text": "Lesotho",
        "value": "Lesotho"
      },
      {
        "text": "Liberia",
        "value": "Liberia"
      },
      {
        "text": "Libyan Arab Jamahiriya",
        "value": "Libyan Arab Jamahiriya"
      },
      {
        "text": "Liechtenstein",
        "value": "Liechtenstein"
      },
      {
        "text": "Lithuania",
        "value": "Lithuania"
      },
      {
        "text": "Luxembourg",
        "value": "Luxembourg"
      },
      {
        "text": "Macau",
        "value": "Macau"
      },
      {
        "text": "Macedonia",
        "value": "Macedonia"
      },
      {
        "text": "Madagascar",
        "value": "Madagascar"
      },
      {
        "text": "Malawi",
        "value": "Malawi"
      },
      {
        "text": "Malaysia",
        "value": "Malaysia"
      },
      {
        "text": "Maldives",
        "value": "Maldives"
      },
      {
        "text": "Mali",
        "value": "Mali"
      },
      {
        "text": "Malta",
        "value": "Malta"
      },
      {
        "text": "Marshall Islands",
        "value": "Marshall Islands"
      },
      {
        "text": "Martinique",
        "value": "Martinique"
      },
      {
        "text": "Mauritania",
        "value": "Mauritania"
      },
      {
        "text": "Mauritius",
        "value": "Mauritius"
      },
      {
        "text": "Mayotte",
        "value": "Mayotte"
      },
      {
        "text": "Mexico",
        "value": "Mexico"
      },
      {
        "text": "Micronesia, Federated States of",
        "value": "Micronesia, Federated States of"
      },
      {
        "text": "Moldova, Republic of",
        "value": "Moldova, Republic of"
      },
      {
        "text": "Monaco",
        "value": "Monaco"
      },
      {
        "text": "Mongolia",
        "value": "Mongolia"
      },
      {
        "text": "Montserrat",
        "value": "Montserrat"
      },
      {
        "text": "Morocco",
        "value": "Morocco"
      },
      {
        "text": "Mozambique",
        "value": "Mozambique"
      },
      {
        "text": "Myanmar",
        "value": "Myanmar"
      },
      {
        "text": "Namibia",
        "value": "Namibia"
      },
      {
        "text": "Nauru",
        "value": "Nauru"
      },
      {
        "text": "Nepal",
        "value": "Nepal"
      },
      {
        "text": "Netherlands",
        "value": "Netherlands"
      },
      {
        "text": "Netherlands Antilles",
        "value": "Netherlands Antilles"
      },
      {
        "text": "New Caledonia",
        "value": "New Caledonia"
      },
      {
        "text": "New Zealand",
        "value": "New Zealand"
      },
      {
        "text": "Nicaragua",
        "value": "Nicaragua"
      },
      {
        "text": "Niger",
        "value": "Niger"
      },
      {
        "text": "Nigeria",
        "value": "Nigeria"
      },
      {
        "text": "Niue",
        "value": "Niue"
      },
      {
        "text": "Norfork Island",
        "value": "Norfork Island"
      },
      {
        "text": "Northern Mariana Islands",
        "value": "Northern Mariana Islands"
      },
      {
        "text": "Norway",
        "value": "Norway"
      },
      {
        "text": "Oman",
        "value": "Oman"
      },
      {
        "text": "Pakistan",
        "value": "Pakistan"
      },
      {
        "text": "Palau",
        "value": "Palau"
      },
      {
        "text": "Panama",
        "value": "Panama"
      },
      {
        "text": "Papua New Guinea",
        "value": "Papua New Guinea"
      },
      {
        "text": "Paraguay",
        "value": "Paraguay"
      },
      {
        "text": "Peru",
        "value": "Peru"
      },
      {
        "text": "Philippines",
        "value": "Philippines"
      },
      {
        "text": "Pitcairn",
        "value": "Pitcairn"
      },

      {
        "text": "Portugal",
        "value": "Portugal"
      },
      {
        "text": "Puerto Rico",
        "value": "Puerto Rico"
      },
      {
        "text": "Qatar",
        "value": "Qatar"
      },
      {
        "text": "Reunion",
        "value": "Reunion"
      },
      {
        "text": "Romania",
        "value": "Romania"
      },
      {
        "text": "Russian Federation",
        "value": "Russian Federation"
      },
      {
        "text": "Rwanda",
        "value": "Rwanda"
      },
      {
        "text": "Saint Kitts and Nevis",
        "value": "Saint Kitts and Nevis"
      },
      {
        "text": "Saint Lucia",
        "value": "Saint Lucia"
      },
      {
        "text": "Saint Vincent and the Grenadines",
        "value": "Saint Vincent and the Grenadines"
      },
      {
        "text": "Samoa",
        "value": "Samoa"
      },
      {
        "text": "San Marino",
        "value": "San Marino"
      },
      {
        "text": "Sao Tome and Principe",
        "value": "Sao Tome and Principe"
      },
      {
        "text": "Saudi Arabia",
        "value": "Saudi Arabia"
      },
      {
        "text": "Senegal",
        "value": "Senegal"
      },
      {
        "text": "Seychelles",
        "value": "Seychelles"
      },
      {
        "text": "Sierra Leone",
        "value": "Sierra Leone"
      },
      {
        "text": "Singapore",
        "value": "Singapore"
      },
      {
        "text": "Slovakia",
        "value": "Slovakia"
      },
      {
        "text": "Slovenia",
        "value": "Slovenia"
      },
      {
        "text": "Solomon Islands",
        "value": "Solomon Islands"
      },
      {
        "text": "Somalia",
        "value": "Somalia"
      },
      {
        "text": "South Africa",
        "value": "South Africa"
      },
      {
        "text": "South Georgia South Sandwich Islands",
        "value": "South Georgia South Sandwich Islands"
      },
      {
        "text": "South Sudan",
        "value": "South Sudan"
      },
      {
        "text": "Spain",
        "value": "Spain"
      },
      {
        "text": "Sri Lanka",
        "value": "Sri Lanka"
      },
      {
        "text": "St. Helena",
        "value": "St. Helena"
      },
      {
        "text": "St. Pierre and Miquelon",
        "value": "St. Pierre and Miquelon"
      },
      {
        "text": "Sudan",
        "value": "Sudan"
      },
      {
        "text": "Suriname",
        "value": "Suriname"
      },
      {
        "text": "Svalbarn and Jan Mayen Islands",
        "value": "Svalbarn and Jan Mayen Islands"
      },
      {
        "text": "Swaziland",
        "value": "Swaziland"
      },
      {
        "text": "Sweden",
        "value": "Sweden"
      },
      {
        "text": "Switzerland",
        "value": "Switzerland"
      },
      {
        "text": "Syrian Arab Republic",
        "value": "Syrian Arab Republic"
      },
      {
        "text": "Taiwan",
        "value": "Taiwan"
      },
      {
        "text": "Tajikistan",
        "value": "Tajikistan"
      },
      {
        "text": "Tanzania, United Republic of",
        "value": "Tanzania, United Republic of"
      },
      {
        "text": "Thailand",
        "value": "Thailand"
      },
      {
        "text": "Togo",
        "value": "Togo"
      },
      {
        "text": "Tokelau",
        "value": "Tokelau"
      },
      {
        "text": "Tonga",
        "value": "Tonga"
      },
      {
        "text": "Trinidad and Tobago",
        "value": "Trinidad and Tobago"
      },
      {
        "text": "Tunisia",
        "value": "Tunisia"
      },
      {
        "text": "Turkey",
        "value": "Turkey"
      },
      {
        "text": "Turkmenistan",
        "value": "Turkmenistan"
      },
      {
        "text": "Turks and Caicos Islands",
        "value": "Turks and Caicos Islands"
      },
      {
        "text": "Tuvalu",
        "value": "Tuvalu"
      },
      {
        "text": "Uganda",
        "value": "Uganda"
      },
      {
        "text": "Ukraine",
        "value": "Ukraine"
      },
      {
        "text": "United Arab Emirates",
        "value": "United Arab Emirates"
      },
      {
        "text": "United Kingdom",
        "value": "United Kingdom"
      },
      {
        "text": "United States minor outlying islands",
        "value": "United States minor outlying islands"
      },
      {
        "text": "Uruguay",
        "value": "Uruguay"
      },
      {
        "text": "Uzbekistan",
        "value": "Uzbekistan"
      },
      {
        "text": "Vanuatu",
        "value": "Vanuatu"
      },
      {
        "text": "Vatican City State",
        "value": "Vatican City State"
      },
      {
        "text": "Venezuela",
        "value": "Venezuela"
      },
      {
        "text": "Vietnam",
        "value": "Vietnam"
      },
      {
        "text": "Virigan Islands (British)",
        "value": "Virigan Islands (British)"
      },
      {
        "text": "Virgin Islands (U.S.)",
        "value": "Virgin Islands (U.S.)"
      },
      {
        "text": "Wallis and Futuna Islands",
        "value": "Wallis and Futuna Islands"
      },
      {
        "text": "Western Sahara",
        "value": "Western Sahara"
      },
      {
        "text": "Yemen",
        "value": "Yemen"
      },
      {
        "text": "Yugoslavia",
        "value": "Yugoslavia"
      },
      {
        "text": "Zaire",
        "value": "Zaire"
      },
      {
        "text": "Zambia",
        "value": "Zambia"
      },
      {
        "text": "Zimbabwe",
        "value": "Zimbabwe"
      }
    ],
    country: "Poland",
    errorText: "",
  }),
  created: function () {
    if (this.$store.getters.cartSize < 1) {
      this.$router.push("/koszyk");
    }
  },
  methods: {
    validateEmail: (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    goToCart: function () {
      this.$router.push("/koszyk");
    },
    goToProducts: function () {
      this.$router.push("/produkty");
    },
    setShippingMethod: function (method) {
      this.method = method;
    },
    loadBoxText: function () {
      if (this.boxId.length < 6 || this.boxId.length > 11) {
        this.boxText = `Nie znaleziono paczkomatu!`;
        return;
      }
      clearTimeout(this.boxTimeout);
      var self = this;
      this.boxLoading = false;
      this.boxTimeout = setTimeout(() => {
        self.$axios
          .post("/api/inpost/get", {
            boxId: self.boxId,
          })
          .then(async (response) => {
            if (response.data.success) {
              self.boxLoading = false;
              self.boxText = `${response.data.address} ${response.data.description}`;
            } else {
              self.boxText = `Nie znaleziono paczkomatu!`;

              self.boxLoading = false;
            }
          })
          .catch((error) => {
            self.boxText = `Nie znaleziono paczkomatu!`;
            self.boxLoading = false;
            console.log(error);
          });
      }, 750);
    },

    goToPaymentOptions: function () {
      if (this.method == "pp" || this.method === "courier") {
        if (!this.validateEmail(this.email)) {
          this.errorText = "Podaj prawidłowy adres email!";
          return;
        }
        if (this.firstName.trim().length < 3) {
          this.errorText = "Podaj imię do wysyłki!";
          return;
        }
        if (this.lastName.trim().length < 3) {
          this.errorText = "Podaj nazwisko do wysyłki!";
          return;
        }
        if (this.street.trim().length < 5) {
          this.errorText = "Podaj ulicę do wysyłki!";
          return;
        }
        if (this.zip.trim().length < 5) {
          this.errorText = "Podaj kod pocztowy do wysyłki!";
          return;
        }
        if (this.zip.trim().length < 3) {
          this.errorText = "Podaj miasto do wysyłki!";
          return;
        }
        this.$store.commit("setShippingInfo", {
          method: this.method,
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          street: this.street,
          aptNumber: this.aptNumber,
          zip: this.zip,
          city: this.city,
          country: this.country,
        });
        this.$router.push("/opcje-platnosci");
      }

      if (this.method == "ip") {
        if (!this.validateEmail(this.email)) {
          this.errorText = "Podaj poprawny email!";
          return;
        }
        if (
          this.boxId.trim().length < 6 ||
          this.boxId.trim().length > 11 ||
          this.boxText.includes("znaleziono") ||
          this.boxText.length == 0
        ) {
          this.errorText = "Podaj poprawny kod paczkomatu!";
          return;
        }
        this.$store.commit("setShippingInfo", {
          method: this.method,
          boxId: this.boxId,
          boxText: this.boxText,
          email: this.email
        });
        this.$router.push("/opcje-platnosci");
      }
    },
  },
  components: {},
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
